<script setup lang="ts">
import { computed } from 'vue';

import { useTheme } from '@/composables/useTheme';
import { useTransactionDetails } from '@/composables/useTransactionDetails';
import { useViewBreakpoints } from '@/composables/useViewBreakpoints';

import TransactionDetails from '@/components/transaction-details/TransactionDetails.vue';
import UiModal from '@/components/ui/UiModal.vue';

interface Props {
  forceModal?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  forceModal: false
});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { opened, close, statusModalOpened, feeModalOpened } = useTransactionDetails();
const { lessThanXL } = useViewBreakpoints();
const { resolvedToDark } = useTheme();

const isShown = computed(() => {
  return (
    opened.value &&
    !statusModalOpened.value &&
    !feeModalOpened.value &&
    (lessThanXL.value || props.forceModal)
  );
});

function handleClose(): void {
  close();
  emit('close');
}
</script>

<template>
  <UiModal
    class="transaction-details-modal"
    padding="sm"
    :model-value="isShown"
    @update:model-value="handleClose"
  >
    <TransactionDetails :underlay="resolvedToDark" @close="handleClose" />
  </UiModal>
</template>
